import * as React from 'react';
const ChevronRight = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <path fill="#1A73E9" d="M8.4 8 5.333 4.933 6.268 4l4 4-4 4-.934-.933L8.4 8Z" />
  </svg>
);
export default ChevronRight;
